// React imports.
import React, { Component } from "react";
const Grantees = ({ allGranteesSelected
                    , grantees
                    , toggleGranteeSelected
                    , toggleAllGranteesSelected}) => (
  <div className="verticalList" >
    <label >
      <input type="checkbox"
          name="chkAllGrantees"
          id='chkAllGrantees'
          onChange={e => toggleAllGranteesSelected()}
          checked={!!allGranteesSelected}/>

      <span >All Grant Recipients</span>
    </label>
    {grantees
      .map(grantee => (
        <label key={grantee.granteeId}>
          <input type="checkbox" value={grantee.granteeId}
              onChange={e => toggleGranteeSelected(grantee.granteeId)}
              checked={grantee.granteeSelected}/>
          <span >{grantee.granteeName}</span>
        </label>
      ))}
  </div>
);

export default Grantees;
